export const theme = {
	colors: {
		primary: '#0073d8',
		primaryLight: 'rgba(0, 115, 216, 0.1)',
		primaryDark: '#0049A6',
		secondary: '#3BAA3F',
		secondaryDark: '#007a0d',
		tertiary: '#673ab7',
		primaryText: '#354052',
		secondaryText: '#485465',
		tertiaryText: '#757575',
		primaryBackground: '#f8f8f8',
		secondaryBackground: 'rgba(255, 191, 0, 0.06)',
		trashBackground: '#ec5745',
		disabled: '#212121',
		disabledExtraLight: 'rgba(33, 33, 33, 0.05)',
		disabledLight: 'rgba(33, 33, 33, 0.34)',
		disabledMedium: 'rgba(33, 33, 33, 0.72)',
		primaryBorder: '#e5e5e5',
		secondaryBorder: 'rgba(0, 0, 0, 0.08)',
		inactiveBackground: '#f9f9f9',
		inactiveText: 'rgba(42, 44, 67, 0.54)',
		inactiveBorder: '#d0d0d0',
		shadow: 'rgba(0, 0, 0, 0.1)',
		shadowLight: '#ededed',
		default: '#888888',
		placeholder: '#878787',
		menu: '#2a2c43',
		success: '#4caf50',
		warning: '#FF9800',
		error: '#F44336',
		link: '#00b0ff',
		white: '#ffffff',
		activeNavBorder: 'rgb(196, 220, 255, 0.54)',
		gray: '#e0e0e0',
		chartBorder: '#eaeaea',
		chartTitle: '#9e9e9e',
		chartPercentage: 'rgba(59, 170, 63, 0.72)',
		black: '#000',
		radioBorder: '#d9d9d9',
		chartError: '#fff6d7',
		chartTextError: '#E17614',
		reportsDesc: '#616161',
		reportChartBorder: 'rgb(204, 204, 204)',
		reportToolTipColor: 'rgb(255, 255, 255)',
		switchBrandColor: '#f5f5f5',
		switchPincodeError: '#e6b0aa',
		switchArrow: '#f0f0f0',
		switchRadioDisabled: '#BDBDBD',
		switchListTable: '#eaeced',
		switchTableListColor: '#1f1f1f',
		trainingFooter: '#5e2c9d',
		trainingHeaderText: '#b5b3e9',
		trainingSliderBg: '#eceff1',
		carouselDots: '#cfd8dc',
		switchUpdateBg: '#e1ece6',
		switchSuccessText: '#108340',
		drawerFooter: 'e8e8e8',
		removeBtnColor: '#d82c26',
		switchSameasBg: '#fcfcfc',
		greyMedium: '#cfd8dc',
	},
	font: {
		family: 'Inter',
		size: {
			extraSmall: '10px',
			small: '12px',
			normal: '14px',
			big: '16px',
			large: '18px',
			bigger: '20px',
			mediumLarge: '22px',
			extraLarge: '24px',
			doubleLarge: '32px',
		},
		weight: {
			thin: '300',
			normal: '400',
			medium: '500',
			bold: '700',
		},
	},
	opacity: {
		dark: '0.72',
		medium: '0.54',
		light: '0.34',
		mediumLight: '0.1',
		extraLight: '0.08',
	},
};

export default theme;
